import { Directive, inject } from '@angular/core';

import { WINDOW } from '@ideals/types';

@Directive({
  host: {
    '(click)': 'mailTo($event)',
  },
  selector: '[idealsOpenMailNewTab]',
})
export class OpenMailNewTabDirective {
  readonly #window = inject(WINDOW);

  mailTo(event: MouseEvent): void {
    event?.preventDefault();
    this.#window.open((event.target as HTMLAnchorElement).href, 'Mail');
  }
}
